import React from "react";
import {
  FileInput,
  FormDataConsumer,
  SelectInput,
  TextInput,
  useNotify,
} from "react-admin";
import { useForm } from "react-final-form";

import { Box } from "@material-ui/core";
import { AttachFileIcon } from "../../../components/common/iconography";
import { FileField } from "../../../components/common/FileField";
import {
  ACCEPTED_FILES,
  MAX_FILES,
  ReloadYardStatus,
  ReloadYardStatusChoices,
  SubscriptionStatusChoices,
} from "../../../utils/constants";
import { handleFileChange } from "../../../utils/fileUtils";

const Subscription = (props) => {
  const form = useForm();
  const notify = useNotify();

  return (
    <FormDataConsumer>
      {({ formData }) => (
        <Box flexWrap="wrap" flex={1} mt={"2em"} style={{ width: "100%" }}>
          <Box display={{ xs: "block", sm: "flex" }}>
            <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
              <TextInput
                source="subscription.customerId"
                label="Customer Id"
                variant="outlined"
                fullWidth
              />
            </Box>
            <Box flex={1}>
              <TextInput
                source="subscription.subscriptionId"
                label="Subscription Id"
                variant="outlined"
                fullWidth
              />
            </Box>
          </Box>
          <Box display={{ xs: "block", sm: "flex" }}>
            <Box flex={1}>
              <TextInput
                source="subscription.priceId"
                label="Price Id"
                variant="outlined"
                fullWidth
              />
            </Box>
            <Box flex={1}>
              <TextInput
                source="subscription.name"
                label="Plan"
                variant="outlined"
                fullWidth
                disabled
              />
            </Box>
            <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
              <SelectInput
                source="subscription.status"
                label="Subscription Status"
                variant="outlined"
                fullWidth
                choices={SubscriptionStatusChoices}
                disabled
                helperText="Stripe subscription status"
              />
            </Box>
            <Box flex={1} mr={{ xs: 0, sm: "1em" }}>
              <SelectInput
                source="status"
                label="Status"
                variant="outlined"
                fullWidth
                choices={ReloadYardStatusChoices}
                helperText="Manual status override"
              />
            </Box>
          </Box>
          <Box mb={2} flex={1}>
            <FileInput
              source="attachments"
              label="ATTACHMENTS"
              variant="outlined"
              fullWidth
              placeholder={
                <p>
                  <AttachFileIcon fontSize="large" /> <br /> Drop file(s) to
                  upload, or click to select.
                </p>
              }
              accept={ACCEPTED_FILES}
              multiple
              maxFiles={MAX_FILES}
              options={{ maxFiles: MAX_FILES }}
              onChange={(value) =>
                handleFileChange("attachments", value, form, notify)
              }
            >
              <FileField source="src" title="title" target="_blank" />
            </FileInput>
          </Box>
        </Box>
      )}
    </FormDataConsumer>
  );
};

export default Subscription;
